import styled from "styled-components";
import { Fab as MuiFab } from "@mui/material";

export const Container = styled.div`
  position: fixed;
  top: 330px;
  left: calc(50% + 320px);
  display: flex; /* 플렉스 컨테이너로 변경 */
  flex-direction: column; /* 하위 요소들을 세로 방향으로 배치 */
  align-items: center; /* 가로축 중앙 정렬 */

  @media (max-width: 768px) {
    bottom: 0;
    top: auto; /* top을 auto로 설정하여 우선 순위에서 제외 */
    left: 20px;
    z-index: 100;
    width: calc(100% - 40px);
    justify-content: space-between;
    padding: 0 20px;
    flex-direction: row;
    background-color: ${({ theme }) => theme.colors.WHITE};
    height: 70px;
    border: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const Fab = styled(MuiFab)`
  // position: sticky;
  // top: 100px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  color: ${({ theme }) => theme.colors.BLACK};
  border: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
  border-radius: 8px;
  box-shadow: none;
  margin-left: 16px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  }

  @media (max-width: 768px) {
    margin-left: 0px;
    border: none;
  }
`;

export const FabSave = styled(MuiFab)`
  position: sticky;
  top: 180px;
  margin-top: 16px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  color: ${({ theme }) => theme.colors.BLACK};
  border: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
  border-radius: 8px;
  box-shadow: none;
  margin-left: 16px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  }

  @media (max-width: 768px) {
    margin-top: 0px;
    margin-left: 0px;
    border: none;
  }
`;

export const Save = styled.div`
  position: sticky;
  top: 100px;
  color: ${({ theme }) => theme.colors.BLACK};
  border-radius: 8px;
  box-shadow: none;
  &:hover {
    background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  }
`;

export const ApplyButton = styled.button`
  position: sticky;
  background-color: ${({ theme }) => theme.colors.WHITE};
  color: ${({ theme }) => theme.colors.BLACK};
  border: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
  border-radius: 8px;
  box-shadow: none;
  margin-left: 16px;
  width: 56px;
  display: none;
  &:hover {
    background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  }

  &:hover::after {
    z-index: 100;
    content: "신청서 페이지 바로가기";
    position: absolute;
    bottom: -50%; /* 버튼의 위쪽에 툴팁을 표시 */
    right: 10%;
    margin-bottom: 8px; /* 버튼과 툴팁 간의 거리 */
    background-color: #333; /* 툴팁 배경색 */
    color: white; /* 툴팁 텍스트 색상 */
    padding: 5px 10px; /* 툴팁 내부 여백 */
    border-radius: 4px; /* 툴팁 모서리 둥글게 */
    white-space: nowrap; /* 텍스트가 한 줄에 표시되도록 */
    font-size: 12px; /* 툴팁 텍스트 크기 */
    opacity: 0; /* 초기에는 투명하게 설정 */
    visibility: hidden; /* 초기에는 보이지 않게 설정 */
    transition: opacity 0.2s, visibility 0.2s; /* 애니메이션 추가 */
  }

  &:hover::after {
    opacity: 1; /* 호버 시 툴팁 보이게 설정 */
    visibility: visible; /* 호버 시 툴팁 보이게 설정 */
  }

  @media (max-width: 768px) {
    margin-left: 0px;
    border: none;
    width: auto;
    display: block;
    text-align: center;
    padding: 0 14px;
  }

  cursor: pointer;
`;

export const FabButton = styled.button`
  position: sticky;
  box-shadow: none;
  width: 56px;
  margin-left: 16px;
  display: none;

  &:hover::after {
    z-index: 100;
    content: "미리보기";
    position: absolute;
    bottom: -50%; /* 버튼의 위쪽에 툴팁을 표시 */
    right: 10%;
    margin-bottom: 8px; /* 버튼과 툴팁 간의 거리 */
    background-color: #333; /* 툴팁 배경색 */
    color: white; /* 툴팁 텍스트 색상 */
    padding: 5px 10px; /* 툴팁 내부 여백 */
    border-radius: 4px; /* 툴팁 모서리 둥글게 */
    white-space: nowrap; /* 텍스트가 한 줄에 표시되도록 */
    font-size: 12px; /* 툴팁 텍스트 크기 */
    opacity: 0; /* 초기에는 투명하게 설정 */
    visibility: hidden; /* 초기에는 보이지 않게 설정 */
    transition: opacity 0.2s, visibility 0.2s; /* 애니메이션 추가 */
  }

  &:hover::after {
    opacity: 1; /* 호버 시 툴팁 보이게 설정 */
    visibility: visible; /* 호버 시 툴팁 보이게 설정 */
  }

  @media (max-width: 768px) {
    margin-left: 0px;
    border: none;
    background-color: ${({ theme }) => theme.colors.WHITE};
    display: block;
  }

  cursor: pointer;
`;
